
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Database } from '@/integrations/supabase/types';

// Define a more flexible type that matches what we're actually using
type BlogPost = Partial<Database['public']['Tables']['blog_posts']['Row']>;

export function usePopularPosts(limit = 3) {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPopularPosts = async () => {
      setLoading(true);

      try {
        const { data, error } = await supabase
          .from('blog_posts')
          .select('id, title, slug, featured_image, view_count, created_at')
          .eq('status', 'published')
          .order('view_count', { ascending: false })
          .limit(limit);

        if (error) throw error;
        
        setPosts(data || []);
      } catch (err) {
        console.error('Error fetching popular posts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPopularPosts();
  }, [limit]);

  return { posts, loading };
}
